// Shared ortho record logic used by BOTH surfaces (chairside Doctor View and
// the patient Ortho tab). Keeping this in one place is what stops the two
// screens from drifting apart again.

// Wire progression is a ladder. Given the clinic's ordered wire options and the
// wire currently on the teeth (from the last visit), suggest the next wire up.
// On a bonding visit there is no current wire, so the suggestion is the first
// (lightest) wire — the starting archwire.
export function suggestNextWire(wireOptions, currentWireId) {
  const opts = Array.isArray(wireOptions) ? wireOptions : [];
  if (!opts.length) return null;
  if (!currentWireId) return opts[0];
  const idx = opts.findIndex((w) => w.id === currentWireId);
  if (idx === -1) return opts[0];
  return opts[idx + 1] || null;
}
